import ValoresRepository from '@/services/ValoresRepository'

export default {
  namespaced: true,
  state: {
    listaGrupoExplotacion: [],
  },
  getters: {
    getGruposGanaderia: (state)=>{
      return state.listaGrupoExplotacion.filter(grupo => grupo.categoria === 2 && grupo.tipo === 1)
    },
    getGruposAgricultura: (state)=>{
      return state.listaGrupoExplotacion.filter(grupo => grupo.categoria === 1 && grupo.tipo === 1)
    },
    getGruposGanaderiaCompleto: (state)=>{
      return state.listaGrupoExplotacion.filter(grupo => grupo.categoria === 2)
    },
    getGruposAgriculturaCompleto: (state)=>{
      return state.listaGrupoExplotacion.filter(grupo => grupo.categoria === 1)
    }
  },
  mutations: {
    setListaGrupoExplotacion(state, listaGrupoExplotacion) {
      state.listaGrupoExplotacion = listaGrupoExplotacion
    },

    clearListaGrupoExplotacion(state) {
      state.listaGrupoExplotacion = []
    },
  },
  actions: {
    async fetchListaGrupoExplotacionParameter({state, commit}) {
      if (state.listaGrupoExplotacion && state.listaGrupoExplotacion.length > 0) {
        return
      }

      let listaGrupoExplotacion = await ValoresRepository.listaGrupoExplotacion()
      commit('setListaGrupoExplotacion', listaGrupoExplotacion)
    },

    clearListaGrupoExplotacion({commit}) {
      commit('clearListaGrupoExplotacion')
    },
  }
}
